export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            examHeads: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        examHeads(state) {
            return state.examHeads.map((item, sl) => {
                item.sl = sl + 1;
                item.status_text = item.status == 'a' ? 'Active' : 'Inactive'; 
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setHead(state, examHeads) {
            state.examHeads = examHeads
        },
    },

    actions: {
        async getExamHeads(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-exam-heads`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setHead', res.data.examHeads);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveExamHead(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-exam-head';
            } else {
                url = 'add-exam-head';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getExamHeads');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteExamHead(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-exam-head/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getExamHeads');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async updateStatus(context, payload) {
            let isSuccess = false;
            await axios.post(`${this.state.host}/change-examhead-status`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getExamHeads');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },
    }
}
